import React, { useEffect } from 'react';
import styled from 'styled-components';
import { theme } from 'styles';

export function Dim({ open, onClick, children, ...props }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <Container $open={open} onClick={onClick} {...props}>
      {children}
    </Container>
  );
}

const Container = styled.div`
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100svh;
  background-color: ${theme.colors.dimSoft};
  z-index: 50;
`;
